import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Box, Button, Container, Grid, IconButton } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import SearchIcon from "@material-ui/icons/Search";
import Tooltip from "@material-ui/core/Tooltip";
import { defaultErrorToast } from "../../../styles/global";
import { useProfile } from "../../../hooks/profile";
import { Label, RequiredStar } from "../../../styles/styles";
import { canceleWayBill } from "../../../services/gisService";
import SelecteWayBillNbrModal from "../SelecteWayBillNbrModal";

export const CanceEWayBill = () => {
	const { orgId } = useProfile();
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	const { register, errors, handleSubmit, reset, clearErrors } = useForm({
		mode: "onTouched",
		defaultValues: {},
	});

	const [iseWayBillSelected, seteWayBillSelected] = useState(true);
	const [selectedeWayBillNbr, setSelectedeWayBillNbr] = useState();

	const openeWayBillDialog = () => {
		setShoweWayBillSearchModal(true);
	};

	const [showeWayBillSearchModal, setShoweWayBillSearchModal] = useState(!iseWayBillSelected);
	const handleeWayBillModalClose = () => setShoweWayBillSearchModal(false);

	const eWayBillSelector = (chooseneWayBill) => {
		setSelectedeWayBillNbr(chooseneWayBill);
		seteWayBillSelected(true);
		if (errors.ewayBillNBR) {
			errors.ewayBillNBR.message = "";
		}
	};

	// Submit
	const submitRequest = async (data) => {
		try {
			let cancelData = {
				cancelReason: data.reason,
			};

			if (data.remarks) {
				cancelData = {
					...cancelData,
					cancelRemarks: data.remarks,
				};
			}

			await canceleWayBill(orgId, data.ewayBillNBR, cancelData);

			// console.log(ewayBillData);
			enqueueSnackbar(`eWayBill Cancelled.  ${data.ewayBillNBR}`, {
				variant: "success",
			});
			history.push("/");
		} catch (e) {
			enqueueSnackbar(defaultErrorToast(e), {
				variant: "error",
			});
		}
	};

	return (
		<Container>
			<Box pt={3} pb="28px">
				<Form onSubmit={handleSubmit(submitRequest)}>
					<Grid container spacing={2}>
						<Grid item xs={12} md={12}>
							<Form.Group controlId="ewayBillNBR">
								<Label>
									<span>
										eWayBill Number
										<RequiredStar />
										<Box component={Tooltip} ml={1} title="Search">
											<IconButton
												color="primary"
												variant="contained"
												aria-label="search"
												component="span"
												size="small"
												onClick={openeWayBillDialog}
											>
												<SearchIcon />
											</IconButton>
										</Box>
									</span>
									{errors.ewayBillNBR && (
										<p className="form-error-inline">
											{errors.ewayBillNBR.message}
										</p>
									)}
								</Label>
								<Form.Control
									name="ewayBillNBR"
									type="text"
									value={selectedeWayBillNbr}
									ref={register({
										required: "Required",
									})}
									onChange={(e) => {
										setSelectedeWayBillNbr(e.target.value);
									}}
								/>
								<SelecteWayBillNbrModal
									orgId={orgId}
									eWaySelector={eWayBillSelector}
									showeWaySearchModal={showeWayBillSearchModal}
									handleClose={handleeWayBillModalClose}
								/>
							</Form.Group>
						</Grid>

						<Grid item xs={12} md={12}>
							<Form.Group controlId="reason">
								<Label>
									<span>
										Reason
										<RequiredStar />
									</span>
									{errors.reason && (
										<p className="form-error-inline">{errors.reason.message}</p>
									)}
								</Label>

								<Form.Control
									as="select"
									name="reason"
									ref={register({
										required: "Required",
									})}
								>
									<option key="Duplicate" value="Duplicate">
										Duplicate
									</option>
									<option key="Data entry mistake" value="Data entry mistake">
										Data entry mistake
									</option>
									<option key="Order cancelled" value="Order cancelled">
										Order cancelled
									</option>
									<option key="Others" value="Others">
										Others
									</option>
								</Form.Control>
							</Form.Group>
						</Grid>

						<Grid item xs={12} md={12}>
							<Form.Group controlId="remarks">
								<Label>
									<span>
										Remarks <RequiredStar />
									</span>
									{errors.remarks && (
										<p className="form-error-inline">
											{errors.remarks.message}
										</p>
									)}
								</Label>
								<Form.Control
									name="remarks"
									type="text"
									as="textarea"
									style={{ height: 100 }}
									ref={register({
										required: "Required",
									})}
								/>
							</Form.Group>
						</Grid>

						<Grid item container justify="space-between">
							<Grid item xs={6}>
								<Button
									color="secondary"
									onClick={() => {
										setSelectedeWayBillNbr();
										reset();
										clearErrors();
									}}
									css={`
										padding: 0;
										font-weight: 600;
									`}
								>
									Clear
								</Button>
							</Grid>
							<Grid item>
								<Button
									variant="outlined"
									color="primary"
									type="submit"
									disableFocusRipple
								>
									Cancel eWayBill
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Form>
			</Box>
		</Container>
	);
};

export default CanceEWayBill;
